// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2bokp","upload":"Small_upload__2r1RC","imageWrap":"Small_imageWrap__27afc","removeBtn":"Small_removeBtn__3D6og"};